import { render, staticRenderFns } from "./SendTeacherAppsend.vue?vue&type=template&id=1248d3f4&scoped=true"
import script from "./SendTeacherAppsend.vue?vue&type=script&lang=js"
export * from "./SendTeacherAppsend.vue?vue&type=script&lang=js"
import style0 from "./SendTeacherAppsend.vue?vue&type=style&index=0&id=1248d3f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1248d3f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1248d3f4')) {
      api.createRecord('1248d3f4', component.options)
    } else {
      api.reload('1248d3f4', component.options)
    }
    module.hot.accept("./SendTeacherAppsend.vue?vue&type=template&id=1248d3f4&scoped=true", function () {
      api.rerender('1248d3f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/birthdaymanagement/SendTeacherAppsend.vue"
export default component.exports